import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface VehicleFilterButtonProps {
    showArchived: boolean;
    onFilterChange: (newFilter: boolean) => void;
}



const VehicleFilterButton = ({ showArchived, onFilterChange }: VehicleFilterButtonProps) => {

    const handleFilterChange = (_event: React.MouseEvent<HTMLElement>, newFilter: boolean) => {
        if (newFilter !== null) {
            onFilterChange(newFilter);
        }
    };

    const { t } = useTranslation()
    return (
        <ToggleButtonGroup
            value={showArchived}
            exclusive
            onChange={handleFilterChange}
            aria-label="Vehicle filter"
            sx={{ height: '40px' }}
        >
            <ToggleButton value={true} aria-label="All vehicles">
                {t("deviceStatus.allVehicles")}
            </ToggleButton>
            <ToggleButton value={false} aria-label="Active vehicles">
                {t("deviceStatus.active")}
            </ToggleButton>
        </ToggleButtonGroup>
    );
};

export default VehicleFilterButton;
